import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
})
export class ExpansionPanelComponent implements OnInit {
  @Input() title: string;
  @Input() project: any;
  @Input() active: boolean;
  @Output() toggle = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}
}
